import React from 'react'
import logo from '../Images/logo.png'
import bg1 from '../Images/bg1.png'
import bg2 from '../Images/bg2.png'
import { RWebShare } from 'react-web-share'
import { useTranslation } from 'react-i18next'
import illustrateImage from '../Images/Illustrator.svg'

const WelcomePage = () => {
    const { t } = useTranslation()

    return (
        <div className="submitPage container-fluid">
            <div className="row">
                <div className="col-5 col-lg-5 col-12">
                    <div className="leftSide">
                        <img
                            src={logo}
                            alt="bglogo"
                            id="logo"
                            className="img-fluid"
                        />
                        <img
                            src={bg2}
                            alt="background"
                            id="bgImage2"
                            className="img-fluid"
                        />
                        <img
                            src={illustrateImage}
                            alt="Illustateimage"
                            id="mainImage"
                            className="img-fluid"
                        />
                        <img
                            src={bg1}
                            alt=""
                            id="bgImage1"
                            className="img-fluid"
                        />
                    </div>
                </div>
                <div className="col-7 col-lg-7 col-12">
                    <div className="rightSide d-flex flex-column justify-content-center align-item-center">
                        <h5>{t('thankyou')}</h5>
                        <p>{t('tyMessage')}</p>
                        <RWebShare
                            data={{
                                text: 'Hey, I took this survey and I invite you to take the same in an effort to boost the influencer community:',
                                url: 'https://influencercommunityofindia.com/',
                                title: 'ICI'
                            }}
                            onClick={() => console.log('shared successfully!')}>
                            <button id="shareBtn">{t('shareBtn')}</button>
                        </RWebShare>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WelcomePage
